import { Component, OnInit, ChangeDetectorRef, OnDestroy, AfterViewInit } from '@angular/core';
import { MediaMatcher } from '@angular/cdk/layout';
//import { TimerObservable } from 'rxjs/observable/TimerObservable';
import { Subscription } from 'rxjs';

import { environment } from './../../../environments/environment';
import { AuthenticationService } from './../../core/services/auth.service';
import { SpinnerService } from '../../core/services/spinner.service';
import { AuthGuard } from 'src/app/core/guards/auth.guard';

@Component({
    selector: 'app-layout',
    templateUrl: './layout.component.html',
    styleUrls: ['./layout.component.css']
})
export class LayoutComponent implements OnInit, OnDestroy, AfterViewInit {

    private _mobileQueryListener: () => void;
    mobileQuery: MediaQueryList;
    showSpinner: boolean;
    userName: string;
    rol = '';
    menu = {
        'vendedor': [
        {
            label: 'Dashboard', 
            icon: 'dashboard',
            route: '/dashboard'
        },
        {
            label: 'Calendario', 
            icon: 'date_range',
            route: '/calendario'
        },
        {
            label: 'Prospectos', 
            icon: 'assignment_late',
            route: '/prospectos'
        },
        {
            label: 'Clientes', 
            icon: 'explicit',
            route: '/clientes'
        },
        {
            label: 'Oportunidades', 
            icon: 'feedback',
            route: '/oportunidades'
        }, 
        /*{
            label: 'Cotizaciones', 
            icon: 'paid',
            route: '/cotizaciones'
        },*/
        {
            label: 'Contactos', 
            icon: 'assignment_ind',
            route: '/contactos'
        },
        {
            label: 'Informes', 
            icon: 'reorder',
            route: '/reportes'
        },],
        'administrador': [
        {
            label: 'Dashboard', 
            icon: 'dashboard',
            route: '/dashboard'
        },],
        'gerente': [
        {
            label: 'Dashboard', 
            icon: 'dashboard',
            route: '/dashboard'
        },
        {
            label: 'Calendario', 
            icon: 'date_range',
            route: '/calendario'
        },
        {
            label: 'Prospectos', 
            icon: 'assignment_late',
            route: '/prospectos'
        },
        {
            label: 'Clientes', 
            icon: 'explicit',
            route: '/clientes'
        },
        {
            label: 'Oportunidades', 
            icon: 'feedback',
            route: '/oportunidades'
        },
        {
            label: 'Contactos', 
            icon: 'assignment_ind',
            route: '/contactos'
        },
        {
            label: 'Informes', 
            icon: 'reorder',
            route: '/reportes'
        },],
        'validador': [
            {
                label: 'Solicitudes',
                icon: 'task_alt',
                route: '/solicitudes'
            },
        ]
    }

    private autoLogoutSubscription: Subscription;

    constructor(private changeDetectorRef: ChangeDetectorRef,
        private media: MediaMatcher,
        public spinnerService: SpinnerService,
        private authService: AuthenticationService,
        private authGuard: AuthGuard) {

        this.mobileQuery = this.media.matchMedia('(max-width: 769px)');
        this._mobileQueryListener = () => {changeDetectorRef.detectChanges()};
        // tslint:disable-next-line: deprecation
        this.mobileQuery.addListener(this._mobileQueryListener);
    }

    logOut() {
        this.authService.logout();
    }

    ngOnInit(): void {
        const user = this.authService.getCurrentUser();
        this.userName = user.name;
        this.rol = user.roles[0].name;
        

        var img = document.createElement("img");
 
        img.src = "../../../assets/logo/printec_black.png";
        let navbarEl: HTMLElement = document.getElementById('navbar')!;
        
        navbarEl.appendChild(img);
        //navbarEl.append("<div fxFlex='100' fxLayoutAlign='center end'><img src='../../../assets/logo/printec_black.png' style='width: 100px;' /></div>")
        // Auto log-out subscription
        /*const timer = TimerObservable.create(2000, 5000);
        this.autoLogoutSubscription = timer.subscribe(t => {
            this.authGuard.canActivate();
        });*/
    }

    ngOnDestroy(): void {
        // tslint:disable-next-line: deprecation
        this.mobileQuery.removeListener(this._mobileQueryListener);
        //this.autoLogoutSubscription.unsubscribe();
    }

    ngAfterViewInit(): void {
        this.changeDetectorRef.detectChanges();
    }

    onCloseMenu(snav) : void {
        if (this.mobileQuery.matches) {
            snav.toggle();
        }
    }

    
}
